
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1920","height":"395.393"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Trazado 599","d":"M0 0v395.393l459.311-53.428q4.178-.486 8.386-.639a93.141 93.141 0 0089.711-93.078v-27a86.879 86.879 0 0186.878-86.879H1920V.002z","fill":"#4d7fb2"}})])
          )
        }
      }
    